import "./layout.scss";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar/navbar";
import Bottombar from "../Bottombar/bottombar";
import Join from "../Join/join";
import SaleBanner from "../SaleBanner/salebanner";

const Layout = () => {
  return (
    <div className="App">
      <Navbar />
      <Outlet />
      <Bottombar />
      <SaleBanner />
      <Join />
    </div>
  );
};

export default Layout;
